import { ComplianceStandardsWebComponent } from './component/ComplianceStandardsWebComponent';

export { ComplianceStandardsWebComponent };
